import React from 'react';

/**
 * Button (spec §4). variant="primary" (gold fill) | "secondary" (card + hairline).
 */
const base =
  'inline-flex items-center justify-center gap-2 font-semibold rounded-arc-ctl px-4 py-2.5 ' +
  'shadow-arc-sm transition disabled:opacity-50 disabled:shadow-none disabled:cursor-not-allowed';

const variants = {
  primary: 'bg-arc-accent text-white hover:brightness-105 active:brightness-95',
  secondary: 'bg-arc-card text-arc-ink ring-1 ring-arc-line hover:bg-arc-paper-2',
};

const Button = ({ variant = 'primary', className = '', children, ...props }) => (
  <button className={[base, variants[variant] ?? variants.primary, className].join(' ')} {...props}>
    {children}
  </button>
);

export default Button;
